var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.brandList.length > 0)?_c('div',{staticClass:"leftMenu light-scrollbar"},_vm._l((_vm.brandList),function(item,index){return _c('div',{key:index,staticClass:"menuItem",class:{ menuChecked: _vm.activeIndex === index },on:{"click":function($event){return _vm.onCheck(index)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }